import { inject, Injectable } from '@angular/core';
import { isDefined } from '@sama/js-core';
import { InjectableSuperclass } from '@sama/ng-core';
import { combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  getProjectionType,
  ProjectionType,
} from '../../cross-team-shared/misc-utils/projection-utils';
import { settingsStoreToken } from '../../cross-team-shared/state/setting-state';
import { PointCloudContentStore } from '../state/point-cloud-content-store';
import { getCameraData } from '../utils/calibration-utils';

@Injectable()
export class CalibrationService extends InjectableSuperclass {
  private settingsStore = inject(settingsStoreToken);

  constructor(private store: PointCloudContentStore) {
    super();
  }

  getProjectionType(outputName: string): ProjectionType {
    const calibrationData = this.store.state().calibrationData[outputName];
    if (!isDefined(calibrationData)) {
      return 'pinhole';
    }

    return getProjectionType(
      calibrationData,
      this.store.state().task,
      outputName,
    );
  }

  getCameraData$(videoOutputName: string) {
    return combineLatest([
      this.store('render')('frameNumber').$,
      this.store('calibrationData')(videoOutputName).$.pipe(filter(isDefined)),
      this.store('render')('calibrationOptions')(videoOutputName).$.pipe(
        filter(isDefined),
      ),
    ]).pipe(
      map(([frameNumber]) =>
        getCameraData(
          this.store.state().calibrationData[videoOutputName],
          this.settingsStore.state().calibrationOptions[videoOutputName],
          frameNumber,
        ),
      ),
    );
  }
}
